export class BuildVersion {
	public static readonly buildNumber: string = '20261013.1';
	public static readonly buildPageLink: string = 'https://dev.azure.com/csc-ddsb/OpenSIMS/_build/results?buildId=72756';
}
